module.exports = __webpack_public_path__ + "assets/ed6bb9bb83847eefcbc910d083baf2bd.mp3";